import { Button } from "@mui/material";
import React from "react";

function FormButtons({ isLoading, isNonMobile }) {
  return (
    <>
      <Button
        type="submit"
        variant="contained"
        color="primary"
        sx={{ width: isNonMobile ? "50%" : "100%", mt: "1rem" }}
      >
        {isLoading ? "Loading..." : "Login"}
      </Button>
    </>
  );
}

export default FormButtons;
